import React from 'react';
import { Container, Typography } from '@mui/material';

function Register() {
	return (
		<Container>
			<Typography variant="h4"> Registrierung </Typography>
		</Container>
	);
}

export default Register;
